export default {"src":"/_next/static/media/hat_glass.64a747f7.svg","height":68,"width":68,"blurWidth":0,"blurHeight":0};